<template>
    <div class="training-main" v-if="body_show">
        <h2 class="title">「7天职业发展特训营」入营信息表</h2>
        <div class="form_grouping">
            <!-- 姓名 -->
            <van-cell-group class="grouping">
                <van-field placeholder="请填写您的姓名"  v-model="info.name" label="姓名"  />
            </van-cell-group>
            <!-- 年龄 -->
            <van-cell-group class="grouping">
                <van-field placeholder="填写具体数字即可"  v-model="info.age" label="我的年龄"  />
            </van-cell-group>
            <!-- 地址 -->
            <van-cell-group class="grouping">
                <van-field placeholder="省/直辖市"  v-model="info.province_city" label="地址" @click="citys_show=true" readonly  />
                <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
            </van-cell-group>
            <van-popup v-model="citys_show" position="bottom">
                 <van-area ref="areas" :area-list="areaList" :columns-num="2" :value="areaList_value"  @cancel="citys_show=false" @confirm="cityConfirm" />
            </van-popup>
            <!-- 工作年限 -->
            <van-cell-group class="grouping">
                <van-field placeholder="请选择工作年限"  v-model="info.seniority" label="工作年限" @click="pickerType(1)" readonly />
                <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
            </van-cell-group>
            <!-- 我目前的岗位职级 -->
            <van-cell-group class="grouping on">
                <van-field placeholder="请选择岗位职级"  v-model="info.rank" label="我目前的岗位职级" @click="pickerType(2)" readonly />
                <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
            </van-cell-group>
            <!-- 课程期待 -->
            <div class="style_tags mt">
                <h2>我来参加本课程，主要期待是（最多选2项）</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.expectations">
                        <van-checkbox :class="{'last-checkbox':style_group.length-1==index}"  v-for="(item,index) in style_group" :key="index"  :disabled="info.expectations.indexOf(item)<0 && info.expectations.length>=2" :name="item">{{item}}</van-checkbox>
                        <van-field  :disabled="info.expectations.length>2 || info.expectations.indexOf('其他')<0" @focus="addCheckbox('expectations')"  class="training-other pull-right clearfix"  v-model="expectations_name"   />
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 我和新精英的熟悉程度 -->
            <div class="style_tags mt">
                <h2>我和新精英的熟悉程度</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.xjy_extent">
                        <van-checkbox   v-for="(item,index) in style_group_two" :key="index"   :name="item">{{item}}</van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 此前遇到职业发展的问题，我用过哪些解决方式？ -->
            <div class="style_tags mt">
                <h2>此前遇到职业发展的问题，我用过哪些解决方式？</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.method">
                        <van-checkbox :class="{'last-checkbox':style_group_three.length-1==index}"  v-for="(item,index) in style_group_three" :key="index"   :name="item">{{item}}</van-checkbox>
                        <van-field :disabled="info.expectations.indexOf('其他')<0" @focus="addCheckbox('method')" class="training-other pull-right clearfix"  v-model="method_name"   />
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 我是通过什么渠道报名本课程的？ -->
            <div class="style_tags mt">
                <h2>我是通过什么渠道报名本课程的？</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="info.source">
                        <van-radio :class="{'last-checkbox':style_group_four.length-1==index}"  v-for="(item,index) in style_group_four" :key="index" :name="item">{{item}}</van-radio>
                        <van-field :disabled="info.source != '其他'" @focus="addCheckbox('source')" class="training-other pull-right clearfix"  v-model="source_name"   />
                    </van-radio-group>
                </div>
            </div>
            <!-- 提交 -->
            <div  class="submit">
                <van-button :class="['btn',validation?'on':'']" @click="submitHandle" type="default">提交并查看班主任微信</van-button>
            </div>
        </div>
        <van-popup v-model="picker_show" position="bottom">
            <!-- 工作年限 -->
            <van-picker v-if="picker_type==1" show-toolbar :columns="workage"    @cancel="picker_show=false" @confirm="confirm" />
            <!-- 目前岗位职级 -->
            <van-picker v-if="picker_type==2" show-toolbar :columns="job_grade"   @cancel="picker_show=false" @confirm="confirm" />
        </van-popup>
    </div>
</template>

<script>
import areaList  from '@/utils/area'
import { getInfo,setInfo } from "@/api/training";
import { shareCon } from "@/utils/wxconfig";
export default {
    data() {
        return{
            body_show:false,
            // 
            areaList,
            citys_show:false,
            arrow:false,
            picker_show:false,
            picker_type:0,
            // 下拉框值
            workage:['1-3年','3-5年','5-8年','8-10年','10-15年','15年以上','20年以上'],
            job_grade:['一线员工','骨干员工','初级管理者','中层管理者','高管','创始人/CEO','自由职业',],
            // 课程期待
            style_group:['想转型，找到合适的方向','现在的工作不喜欢，想知道怎么办','目前工作还不错，希望提速（升职加薪）','工作遇到瓶颈，找解决办法','找更多可能性','就是想来体验一下','其他'],
            // 熟悉程度
            style_group_two:['「个人战略课」学员','学过《超级个体》','参加过生涯规划课程','担任过个人战略课助教/教练','一直关注公众号，第一次付费购买课程','之前没了解，第一次接触新精英'],
            // 职业发展的问题
            style_group_three:['找专业人士咨询','和朋友聊天','找在线课程/知识付费进行学习','参加线下培训','其他'],
            // 渠道
            style_group_four:['公众号','朋友圈','微信群','其他'],
            // 
            info:{
                age:null,
                expectations:[],
                method:[],
                name:'',
                province_city:'',
                rank:'',
                seniority:'',
                source:'',
                xjy_extent:[]
            },
            expectations_name:'',
            method_name:'',
            source_name:'',
            xjy_extent_name:''
        }
    },
    computed:{
        // 验证
        validation(){
            if(
              this.info.name &&
              this.info.age &&
              this.info.seniority && 
              this.info.province_city && 
              this.info.rank && 
              this.info.expectations.length>0 && 
              this.info.method.length>0 && 
              this.info.source && 
              this.info.xjy_extent.length>0
            ){
                return true;
            }
            return false;
        }
    },
    methods:{
        // 获得焦点时选中
        addCheckbox(name){
            if(name=='source'){
                this.info.source = '其他';
                return;
            }
            console.log(this.info[name].indexOf('其他'));
            if(this.info[name].indexOf('其他')<=0){
                this.info[name].push('其他');
            }
        },
        // 处理其它
        otherHandle(){
            if(this.info.expectations.indexOf('其他')>0){
                let index = this.info.expectations.indexOf('其他');
                this.info.expectations[index] = '其他:'+this.expectations_name;
            }
            if(this.info.method.indexOf('其他')>0){
                let index = this.info.method.indexOf('其他');
                this.info.method[index] = '其他:'+this.method_name;
            }
            if(this.info.source ==='其他'){
                this.info.source = '其他:'+this.source_name;
            }
        },
        // 提交数据
        submitHandle(){
            if(!this.validation){
                this.$toast('请检查数据是否为空哦！');
                return
            }
            this.otherHandle();
            let Obj = {
                name:this.info.name,
                age:this.info.age,
                seniority:this.info.seniority,
                province_city:this.info.province_city,
                rank:this.info.rank,
                expectations:this.info.expectations.join('//'),
                xjy_extent:this.info.xjy_extent.join('//'),
                method:this.info.method.join('//'),
                source:this.info.source
            };
            if(this.info.id){
                Obj['id']  = this.info.id;
            }
            setInfo(Obj).then((data)=>{
                if (data.code && data.code === 10002) {
                    this.$toast(data.data.msg);
                    return;
                }
                this.$toast({
                    message: '提交成功!',
                    duration:1000,
                    onClose:()=>{
                        this.$router.push({
                            path:'/teacher_code',
                            query:{
                                course_id:this.$route.query.course_id
                            }
                        });
                    }
                });
            });
        },
        // 城市
        cityConfirm(picker){
            this.citys_show=false;
            let val = picker[0].name+' '+picker[1].name;
            this.info.province_city = val;

        },
        // 弹出选择框  1 工作年限、2目前所处职级
        confirm(data){
            if(this.picker_type==1){
                this.info.seniority = data;
            }else if(this.picker_type==2){
                this.info.rank = data;
            }

            this.picker_show=false;

        },
        // 判断弹出是什么选择框
        pickerType(type){
            // 1 工作年限、2职级
            this.picker_type=type;
            this.picker_show=true;

        },
        // 截取判断是否有其他
        isOther(list,name){
            let arr = list.split('//');

            for(let i = 0; i<arr.length;i++){

                if(arr[i].indexOf('其他')>=0){
                    this[name] = arr[i].split(':')[1];
                    arr[i] = '其他';
                }
            }
            return arr;
        },
        pullData(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            getInfo().then((data)=>{
                if(data.code && data.code ===10002){
                    this.$toast(data.msg);
                    return
                }
                if(!(data.info instanceof Array)){
                    this.info = {
                        id:data.info.id,
                        age:data.info.age,
                        name:data.info.name,
                        province_city:data.info.province_city,
                        rank:data.info.rank,
                        seniority:data.info.seniority,
                        expectations:this.isOther(data.info.expectations,'expectations_name'),
                        method:this.isOther(data.info.method,'method_name'),
                        xjy_extent:data.info.xjy_extent.split('//'),
                        source:data.info.source.indexOf('其他')>-1?'其他':data.info.source
                    };
                    this.source_name =data.info.source.indexOf('其他')>-1?data.info.source.split(':')[1]:'';
                }
                this.body_show = true;
                this.$toast.clear();
            });
              
        }
    },
    created(){
        this.pullData();
        shareCon("training", this);
    }
}
</script>

<style lang="scss" scoped>
.training-main{
    padding: 30px 0 80px;
    h2.title{
        margin-bottom: 60px;
        font-size:32px;
        color: #EB5032;
    }
}
.style_tags{
    color: #333;
    h2{
        margin-bottom: 30px;
        font-size: 32px;
        text-align: left;
        line-height: 42px;
        font-weight: normal;
    }
    .training-other{
        display: inline-block;
        width: auto;
        line-height: 70px;
        padding: 0 0 0 8px;
        border:2px solid rgba(204,204,204,1);
        border-radius:8px;
        width: 544px;
    }
}
.submit{
    margin-top: 80px;
    text-align: center;
    .btn{
        width:578px;
        line-height:80px;background-color: #CCCCCC;
        border-radius:8px;
        color: #fff;
        font-size:34px;
    }
    .btn.on{
        background:#EB5032;
    }
}
</style>
<style lang="scss">
// 风格标签
.style_tags .van-checkbox-group,.style_tags  .radio-box .van-radio-group{
    .van-checkbox,.van-radio{
        font-size: 26px;
        margin-bottom: 20px;
        line-height:34px;
    }
    .van-checkbox.last-checkbox,.van-radio.last-checkbox{
        display: inline-block;
        line-height: 70px;
        margin-bottom: 0;
    }
    .van-checkbox .van-checkbox__label,.van-radio .van-radio__label{
        position: relative;
        line-height: 1;
    }
    .van-checkbox .van-checkbox__icon,.van-radio .van-radio__icon{
        height: 34px;
        line-height:34px;
    }
    .van-checkbox .van-checkbox__icon .van-icon,.van-radio .van-radio__icon .van-icon{
        width:34px;
        height: 34px;
        border:0;
        border-radius: 0;
        border-color: transparent;
        background-color: transparent;
        background-image: url(../../../assets/normal.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .van-checkbox__icon.van-checkbox__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/press.png);
    }
    .van-radio .van-radio__icon .van-icon{
        background-image: url(../../../assets/radio_.png);
    }
    .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/radio_active.png);
    }
    .van-checkbox .van-checkbox__icon .van-icon:before,.van-radio .van-radio__icon .van-icon:before{
        content:'';
    }
}
.style_tags  .radio-box .van-radio-group{
    
    
    .van-radio .van-radio__icon .van-icon:before{
        content:'';
    }
}

</style>
